import moment from 'moment';

// A completed calendar quarter, `quartersAgo` quarters back from the current
// one (1 = the most recently completed quarter, 2 = the one before that, ...).
export const getQuarterRange = (quartersAgo = 1) => {
  const start = moment().subtract(quartersAgo, 'quarter').startOf('quarter');
  const end = moment().subtract(quartersAgo, 'quarter').endOf('quarter');
  return {
    start,
    end,
    startISO: start.toISOString(),
    endISO: end.toISOString(),
    quarter: start.quarter(),
    year: start.year(),
  };
};

// The most recently completed calendar quarter (not the current, in-progress one).
export const getLastQuarterRange = () => getQuarterRange(1);

export const isWithinRange = (date, start, end) => {
  if (!date) {
    return false;
  }
  const moment_ = moment(date);
  return moment_.isSameOrAfter(start) && moment_.isSameOrBefore(end);
};

// True when [itemStart, itemEnd] overlaps [start, end] at all - e.g. an
// offer that was live at some point during the quarter, not necessarily
// created in it.
export const overlapsRange = (itemStart, itemEnd, start, end) => {
  if (!itemStart && !itemEnd) {
    return false;
  }
  const startsBeforeRangeEnds =
    !itemStart || moment(itemStart).isSameOrBefore(end);
  const endsAfterRangeStarts = !itemEnd || moment(itemEnd).isSameOrAfter(start);
  return startsBeforeRangeEnds && endsAfterRangeStarts;
};

// Percentage change vs the prior quarter, formatted as a pill string
// ("+15%", "-8%", "±0%"). `newLabel` (already translated, e.g. "New")
// is shown when this quarter has activity but the prior one had none.
// Returns undefined when there's nothing meaningful to show.
export const formatQoqPill = (current, previous, newLabel) => {
  if (!previous) {
    return current > 0 ? newLabel : undefined;
  }
  const change = Math.round(((current - previous) / previous) * 100);
  if (change === 0) {
    return '±0%';
  }
  return `${change > 0 ? '+' : ''}${change}%`;
};

// Direction of the same change, for coloring the pill formatQoqPill returns.
export const qoqTone = (current, previous) => {
  if (!previous) {
    return current > 0 ? 'up' : undefined;
  }
  const change = Math.round(((current - previous) / previous) * 100);
  if (change === 0) {
    return 'neutral';
  }
  return change > 0 ? 'up' : 'down';
};
